import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BOOKMARKED_QUESTIONS } from 'legacy/src/constants/common';
import { Storage } from '../../utility/Storage';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Tooltip from '../../utility/Tooltip';

import './styles.scss';

class Bookmark extends PureComponent {
  static displayName = 'Bookmark';

  static propTypes = {
    /**
     * Bool for setting the icon state
     * */
    isBookmarked: PropTypes.bool,
    /**
     * Current question reference provided by getCurrentItem() learnosity method
     * */
    questionReference: PropTypes.string,
    activity: PropTypes.object.isRequired,
    /**
     * Handler for mobile version or not.
     * */
    isMobile: PropTypes.bool,
    isImpersonating: PropTypes.bool,
  };

  static defaultProps = {
    isBookmarked: false,
    isMobile: false,
    isImpersonating: false,
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.notify = this.notify.bind(this);
  }

  componentDidMount() {
    const {
      activity: { session_id },
      isImpersonating,
    } = this.props;
    this.store = new Storage(
      `${BOOKMARKED_QUESTIONS}-${session_id}${isImpersonating ? '-i' : ''}`,
    );
  }

  /**
   * On bookmark icon click handler
   * */
  onClick() {
    const {
      addBookmark,
      removeBookmark,
      isBookmarked,
      questionReference,
      isMobile,
    } = this.props;

    if (!isBookmarked) {
      addBookmark(questionReference);
      this.store.addQuestion(questionReference);
    } else {
      removeBookmark(questionReference);
      this.store.removeQuestion(questionReference);
    }

    const overviewIconContainer = document.querySelector(
      '.overview-icon-container',
    );

    if (overviewIconContainer) {
      if (!isBookmarked) {
        const selectedOverviewIcon = document.querySelector(
          '.overview-icon-container.is-selected',
        );

        const bookmarkedIcon =
          selectedOverviewIcon.querySelector('.bookmarked-icon');
        bookmarkedIcon && bookmarkedIcon.classList.add('visible');
      } else {
        const currentBookmarkedIcon = document.querySelector(
          '.overview-icon-container.is-selected .bookmarked-icon',
        );
        if (currentBookmarkedIcon) {
          currentBookmarkedIcon.classList.remove('visible');
        }
      }
    }

    isMobile && this.notify();
  }

  /**
   * Keydown handler to allow use of
   * - spacebar and return to toggle the bookmark icon
   */
  keyDownHandler = (event) => {
    // only handle pressing of spacebar and return
    if ([13, 32].includes(event.keyCode)) {
      // Make sure to stop event bubbling
      event.preventDefault();
      event.stopPropagation();
      this.onClick();
    }
  };

  /**
   * Adds notification for bookmark and removes it after 3 seconds.
   * */
  notify() {
    const { isBookmarked } = this.props;

    const bodyElement = document.querySelector('body');
    let bookmarkNotification = document.createElement('div');
    bookmarkNotification.classList.add('bookmark-notification');
    bookmarkNotification.innerText = !isBookmarked
      ? 'Bookmark added'
      : 'Bookmark removed';
    bodyElement.appendChild(bookmarkNotification);

    setTimeout(() => {
      bookmarkNotification.remove();
    }, 3000);
  }

  render() {
    const { isBookmarked, tooltipProps } = this.props;

    return (
      <Tooltip {...tooltipProps} autoShow>
        <div>
          <div
            id="bookmarkButton"
            role="button"
            className={`ToolkitButton bookmark-icon ${
              isBookmarked ? 'is-bookmarked' : ''
            }`}
            onClick={!this.props.isMobile ? this.onClick : undefined}
            tabIndex={this.props.isMobile ? '-1' : 0}
            onKeyDown={this.keyDownHandler}
            aria-pressed={isBookmarked ? 'true' : 'false'}
            aria-label={`Bookmark ${
              isBookmarked ? '- Question is bookmarked' : ''
            }`}
          >
            <Icon id="bookmark" accessibility={{ ariaHidden: true }} />
          </div>
        </div>
      </Tooltip>
    );
  }
}

export default Bookmark;
